module.exports = __webpack_public_path__ + "img/平方式.ed292e9e.svg";